const interpolateFallback = (fallback, options) => {
    if (!options || typeof fallback !== 'string') {
        return fallback;
    }

    return fallback.replace(/\{([^}]+)\}/g, (match, key) =>
        Object.prototype.hasOwnProperty.call(options, key)
            ? String(options[key])
            : match
    );
};

export const translateWithFallback = (
    translate,
    key,
    fallback = '',
    options,
    hasTranslation
) => {
    if (
        typeof translate !== 'function' ||
        !key ||
        (typeof hasTranslation === 'function' && !hasTranslation(key))
    ) {
        return interpolateFallback(fallback, options);
    }

    const translated = translate(key, options);

    if (
        translated === undefined ||
        translated === null ||
        translated === '' ||
        translated === key
    ) {
        return interpolateFallback(fallback, options);
    }

    return translated;
};
